document.addEventListener('DOMContentLoaded', () => {

  var ComboSwiper = new Swiper(`.combo-product-list`, {
        slidesPerView: 4,
        spaceBetween: 25,
        observer: true,
        pagination: {
          el: '.combo-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          }
        }
    });

});